<template>
  <div style="height: 100vh; width: 100vm" class="video-chat">
    <div style="height: 10%; width: 100%; min-height: 100px">
      <el-row :gutter="20" style="height: 100%;" type="flex" justify="center" align="middle">
        <el-col :span="20" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">
            <span style="width: 100%">视频会议
              <!--todo delete-->
            <br/>
            ({{`${mediaList.length}/${roomOnlineUsers.length}`}})
            <br/>
              <span style="font-size: 14px" v-if="jyxRtcLoginOptions && jyxRtcJoinRoomOptions">({{`用户id：${jyxRtcLoginOptions.userId}  /用户姓名：${JSON.parse(jyxRtcLoginOptions.userExtInfo).userName} /所在部门：${JSON.parse(jyxRtcLoginOptions.userExtInfo).departmentName} /房间号：${this.jyxRtcJoinRoomOptions.roomId||""}`}})</span>
            </span>
          </el-row>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">在线用户列表
            <br/>
            <!--todo delete-->
            <!--({{onlineUsers.length}})-->
            ({{onlineUsers.length - roomOnlineUsers.length}})
          </el-row>
          <!--<el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"-->
          <!--align="middle">未邀请列表-->
          <!--<br/>-->
          <!--({{onlineUsers.length - roomOnlineUsers.length + 1}})-->
          <!--</el-row>-->
        </el-col>
      </el-row>
    </div>

    <div style="height: 70%; width: 100%;">
      <el-row :gutter="20" style="height: 100%;">
        <el-col :span="20" style="height: 100%; border: 1px solid black; overflow-y: auto; padding-bottom: 40px">
          <el-row type="flex" justify="start" v-for="(mediaList, index) in mediaLists" :key="'media_list_'+index">
            <el-card style="width: 320px; padding: 15px; margin: 10px; float: left; "
                     body-style="padding: 0; "
                     v-for="(media,index) in mediaList" :key="'media_'+index">
              <video :ref="media.ref" src="" width="320px" height="240px" autoplay muted
                     style="margin-bottom: 10px;"></video>
              <span>{{media.mediaName}}</span>
              <!--<el-button type="text" size="small" @click="mediaHandle(media)">{{media.state===2?'暂停':"开始"}}{{media.userId === jyxRtcLoginOptions.userId?"生产":"消费"}}</el-button>-->
            </el-card>
          </el-row>
          <audio :ref="audio.ref" src="" autoPlay :muted="audio.muted" v-for="audio in audioList"
                 :key="'audio_'+audio.id"
                 v-show="false"></audio>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; padding: 0">
          <el-row>
            <i class="el-icon-refresh-right" style="float: right; margin: 10px 20px 10px auto"
               @click="getOnlineUsers(true)"></i>
          </el-row>
          <el-row
            style="height: 60%; font-weight: bold; font-size: 24px; border-bottom: 1px solid black; overflow-y: auto; width: 100%"
            type="flex"
            justify="center">
            <el-checkbox-group v-model="checkedUsers" @change="handleCheckedUsersChange" style="width: 100%">
              <el-row v-for="(onlineUser,index) in onlineUsers.filter((onlineUser) => {return !onlineUser.isInRoom})"
                      :key="'user_'+index" style="margin-top: 10px">
                <el-checkbox :label="onlineUser.userId" style="float: left;" :disabled="onlineUser.isInRoom">
                  {{onlineUser.userExtInfo.userName}}
                </el-checkbox>
              </el-row>
            </el-checkbox-group>
          </el-row>
          <el-row style="height: 35%; width: 100%; font-weight: bold; font-size: 24px; overflow: auto; padding: 10px"
                  id="roomMessageElement">
            <el-row v-for="(roomMessage,index) in roomMessageList" :key="'roomMessage_'+index"
                    style="width: 100%; margin-bottom: 5px; ">
              <el-row type="flex" :justify="jyxRtcLoginOptions.userId === roomMessage.sourceUserId?'end':'start'"
                      align="middle" style="font-size: 14px;margin-top: 5px; width: 100%; color: #8c939d">
                {{jyxRtcLoginOptions.userId === roomMessage.sourceUserId?("我说:")
                :(roomMessage.sourceUserExtInfo.userName+"说:") }}&nbsp;&nbsp;
              </el-row>
              <el-row type="flex" :justify="jyxRtcLoginOptions.userId === roomMessage.sourceUserId?'end':'start'"
                      align="middle" style="width: 100%">
                <el-card style="max-width: 70%; color: white; font-size: 18px; font-weight: normal"
                         body-style="padding: 10px"
                         :style="jyxRtcLoginOptions.userId === roomMessage.sourceUserId?'float: right; background-color: #67C23A':'float: left; background-color: #409EFF'">
                  <div style="word-wrap:break-word; text-align: left">{{roomMessage.message}}</div>
                </el-card>
              </el-row>
              <el-row type="flex" :justify="jyxRtcLoginOptions.userId === roomMessage.sourceUserId?'end':'start'"
                      align="middle" style="font-size: 10px;margin-top: 5px; color: #8c939d">
                {{dateFormat(roomMessage.time)}}&nbsp;&nbsp;
              </el-row>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div style="height: 20%; width: 100%;">
      <el-row :gutter="20" style="height: 100%;" type="flex" justify="center" align="middle">
        <el-col :span="20" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; width: 100%">
            <el-row style="height: 25%; width: 100%;" type="flex" justify="center" align="middle"
                    v-if="devices.cameraDevices && devices.cameraDevices.length">
              <el-button
                v-for="(device,index) in devices.cameraDevices"
                :key="'video_button_'+index"
                @click="videoHandle(device.useState?0:1,device)"
                :disabled="device.useState === 1">
                {{device.useState === 2?"关闭":"开启"}}视频{{index+1}}{{device.useState ===
                1?"中。。。":""}}({{device.deviceName}})
              </el-button>
              <input ref="refImgUploadInput" name="name" type="file" accept=".jpg, .jpeg, .png"
                     style="width: 150px !important;margin-left: 10px">
              <el-button @click="wbDialogVisible = true">互动白板</el-button>
              <el-button @click="startDetection(1)">人脸识别</el-button>
              <el-button @click="startDetection(2)">出入框检测</el-button>
              <el-button @click="startDetection(3)">人脸变化检测</el-button>
              <el-button @click="stopAll">关闭人脸操作</el-button>
            </el-row>
            <el-row style="height: 25%; width: 100%;" type="flex" justify="center" align="middle">
              <el-select v-model="checkedMedia" value-key="id" filterable clearable placeholder="请选择要操作的视频"
                         style="margin-right: 20px">
                <el-option
                  v-for="media in videoList"
                  :key="'video_'+media.id"
                  :label="media.mediaName"
                  :value="media">
                </el-option>
              </el-select>
              <el-button @click="capture()">本地抓拍</el-button>
              <el-button v-if="devices.micDevices && devices.micDevices.length"
                         :disabled="devices.micDevices[0].useState === 1"
                         @click="audioHandle(devices.micDevices[0].useState?0:1,devices.micDevices[0])">
                {{devices.micDevices[0].useState === 2?"关闭":"开启"}}音频{{devices.micDevices[0].useState === 1?"中。。。":""}}
              </el-button>
              <el-button :disabled="shareScreenState === 1" @click="shareScreenHandle(shareScreenState?0:1)">
                {{shareScreenState === 2?"停止":"开启"}}屏幕共享{{shareScreenState === 1?"中。。。":""}}
              </el-button>
              <el-button @click="leaveRoom()">退出房间</el-button>
              <el-button
                @click="invite({roomId: jyxRtcJoinRoomOptions.roomId, roomPassword: jyxRtcJoinRoomOptions.roomPassword, userIds: checkedUsers})">
                邀请
              </el-button>
            </el-row>
            <el-row style="height: 25%; width: 100%;" type="flex" justify="center" align="middle">
              <el-button v-show="mergeRecordOptions.state===0" @click="mergeRecordSetDialogVisible=true" style="margin-right: 20px">录制</el-button>
              <el-button v-show="mergeRecordOptions.state===2" @click="stopMergeRecord()" style="margin-right: 20px">停止录制</el-button>
              <el-button @click="getVideoUrls()" style="margin-right: 20px">点播</el-button>
              <input ref="sendFile" type="file"/>
              <el-button @click="sendData()">发送</el-button>
              <!--&lt;!&ndash; 录制模式 &ndash;&gt;-->
              <!--<el-select v-model="recordType" value-key="id" filterable placeholder="请选择录制模式" style="margin-right: 20px"-->
              <!--:disabled="recordState !== 0"-->
              <!--@change="recordTypeChangeHandle">-->
              <!--<el-option-->
              <!--v-for="recordTypeOption in recordTypeOptions"-->
              <!--:key="'record_type_'+recordTypeOption.value"-->
              <!--:label="recordTypeOption.label"-->
              <!--:value="recordTypeOption.value">-->
              <!--</el-option>-->
              <!--</el-select>-->
              <!--&lt;!&ndash; 选择用户 &ndash;&gt;-->
              <!--<el-select v-model="recordUserId" value-key="id" filterable clearable placeholder="请选择录制用户"-->
              <!--:disabled="recordState !== 0"-->
              <!--style="margin-right: 20px">-->
              <!--<el-option-->
              <!--v-for="mediaUserInfo in mediaUserInfoOptions"-->
              <!--:key="'media_user_info_'+mediaUserInfo.userId"-->
              <!--:label="mediaUserInfo.userName"-->
              <!--:value="mediaUserInfo.userId">-->
              <!--</el-option>-->
              <!--</el-select>-->
              <!--&lt;!&ndash; 合成模式 &ndash;&gt;-->
              <!--<el-select v-model="mergeModel" value-key="id" filterable clearable placeholder="请选择合成模式"-->
              <!--:disabled="recordState !== 0"-->
              <!--style="margin-right: 20px">-->
              <!--<el-option-->
              <!--v-for="mergeModel in mergeModelOptions"-->
              <!--:key="'merge_model_'+mergeModel"-->
              <!--:label="mergeModel"-->
              <!--:value="mergeModel">-->
              <!--</el-option>-->
              <!--</el-select>-->
              <!--<el-button :disabled="recordState === 1" @click="recordHandle(recordState?0:1)">-->
              <!--{{recordState === 2?"停止":"开始"}}录制{{recordState === 1?"中。。。":""}}-->
              <!--</el-button>-->
            </el-row>
            <el-row style="height: 25%; width: 100%;" type="flex" justify="center" align="middle">
              <span style="font-size: 14px; font-weight: normal">循环播放：</span>
              <el-select v-model="isLoop" placeholder="请选择播放模式"
                         :disabled="playAudioState !== 0"
                         style="width: 60px; margin-right: 20px">
                <el-option
                  v-for="(item,index) in [{label:'是',value:true},{label:'否',value:false}]"
                  :key="'loop'+index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <span style="font-size: 14px; font-weight: normal">本地播放：</span>
              <el-select v-model="isPlay" placeholder="是否本地播放"
                         :disabled="playAudioState !== 0"
                         style="width: 60px; margin-right: 20px">
                <el-option
                  v-for="(item,index) in [{label:'是',value:true},{label:'否',value:false}]"
                  :key="'loop'+index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="externalAudioUrl" style="max-width: 200px; margin-right: 20px" clearable></el-input>
              <el-button :disabled="playAudioState === 1" @click="playAudioHandle(playAudioState?0:1)"
                         style="margin-right: 20px">
                {{playAudioState === 2?"停止":"开始"}}播放{{playAudioState === 1?"中。。。":""}}
              </el-button>
              <el-select v-model="checkedCutLocalAudioMedia" value-key="id" filterable clearable placeholder="请选择要截取的音频"
                         style="margin-right: 20px">
                <el-option
                  v-for="media in audioList"
                  :key="'audio_'+media.id"
                  :label="media.mediaName"
                  :value="media">
                </el-option>
              </el-select>
              <!--<span style="font-size: 14px; font-weight: normal">实时录制：</span>-->
              <!--<el-select v-model="isRealTime" placeholder="是否实时录制"-->
              <!--:disabled="cutLocalAudioState !== 0"-->
              <!--style="width: 60px; margin-right: 20px">-->
              <!--<el-option-->
              <!--v-for="(item,index) in [{label:'是',value:true},{label:'否',value:false}]"-->
              <!--:key="'loop'+index"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
              <!--</el-option>-->
              <!--</el-select>-->
              <el-button @click="cutLocalAudioHandle(1)"
                         :disabled="!checkedCutLocalAudioMedia||!!cutLocalAudioState">开始截取本地音频
              </el-button>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="4" style="height: 100%; border: 1px solid black; ">
          <el-row style="height: 100%; font-weight: bold; font-size: 24px; " type="flex" justify="center"
                  align="middle">
            <el-input v-model="message" style="margin-right: 20px" clearable></el-input>
            <el-button @click="sendRoomMessage()"> 发送</el-button>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="抓拍图片"
      :close-on-click-modal="false"
      :visible.sync="captureDialogVisible"
      style="max-height: 100%">
      <el-image :src="imageData" alt="抓拍图片" ref="captureImage"/>
    </el-dialog>
    <el-dialog
      title="截取本地音频"
      width="500px"
      @close="cutLocalAudioHandle(0)"
      :close-on-click-modal="false"
      destroy-on-close
      :visible.sync="cutLocalAudioDialogVisible"
      style="max-height: 100%">
      <audio ref="cutLocalAudio" controls></audio>
      <br>
      <div style="margin: 20px">{{cutLocalAudioState===0?'截取结束':cutLocalAudioState===1?'开始截取中。。。':'正在截取。。。'}}
      </div>
      <el-button @click="cutLocalAudioHandle(cutLocalAudioState?0:1)" :disabled="cutLocalAudioState===0">
        {{cutLocalAudioState === 2?"停止":"开始"}}截取{{cutLocalAudioState === 1?"中。。。":""}}
      </el-button>
      <!--<el-button @click="copyHandle(cutLocalAudioBase64.substring(0, cutLocalAudioBase64.length - 1))" :disabled="!cutLocalAudioBase64">-->
      <!--复制base64-->
      <!--</el-button>-->
      <!--<el-button @click="pauseRecord"> 暂停截取</el-button>-->
    </el-dialog>
    <el-dialog
      title="录制设置"
      :close-on-click-modal="false"
      :visible.sync="mergeRecordSetDialogVisible"
      style="max-height: 100%">
      <el-row>
        <span style="font-size: 14px; font-weight: normal">录制布局：</span>
        <el-select v-model="mergeRecordOptions.options.recordConfig.mixedVideoLayout" placeholder="请选择录制布局"
                   style="width: 240px; margin-right: 20px">
          <el-option
            v-for="(item,index) in [{label:'0_1 悬浮布局（<=5人）',value:'0_1'}
                      ,{label:'0_2 悬浮布局（<=9人）',value:'0_2'}
                      ,{label:'1_0 自适应布局（1人）',value:'1_0'}
                      ,{label:'1_1 自适应布局（2人）',value:'1_1'}
                      ,{label:'1_2 自适应布局（<=4人）',value:'1_2'}
                      ,{label:'1_3 自适应布局（<=9人）',value:'1_3'}
                      ,{label:'2_0垂直布局（1人）',value:'2_0'}
                      ,{label:'2_1垂直布局（<=4人）',value:'2_1'}
                      ,{label:'2_2垂直布局（<=7人）',value:'2_2'}]"
            :key="'layout'+index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="font-size: 14px; font-weight: normal">视频大小：</span>
        <el-select v-model="mergeRecordOptions.checkedResolvingPower" placeholder="请选择视频大小"
                   style="width: 240px; margin-right: 20px"
                   value-key="id">
          <el-option
            v-for="(item,index) in [{id: 0, label: '640*480', width: 640, height: 480},
                        {id: 1, label: '1280*720', width: 1280, height: 720},
                        {id: 2, label: '1920*1080', width: 1920, height: 1080},
                        {id: 4, label: '480*640', width: 480, height: 640},
                        {id: 5, label: '720*1280', width: 720, height: 1280},
                        {id: 6, label: '1080*1920', width: 1080, height: 1920},
                        {id: 7, label: '360*560', width: 360, height: 560}]"
            :key="'resolvingPower'+index"
            :label="item.label"
            :value="item">
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="font-size: 14px; font-weight: normal">水印模式：</span>
        <el-select v-model="mergeRecordOptions.options.watermarkConfig.type" placeholder="请选择水印模式"
                   style="width: 240px; margin-right: 20px">
          <el-option
            v-for="(item,index) in [{id: 0, label: '自定义', value: '1'},
                                    {id: 1, label: '时间戳', value: '2'}]"
            :key="'watermark'+index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <br>
        <span style="font-size: 14px; font-weight: normal; margin-right: 74px"></span>
        <el-input v-model="mergeRecordOptions.options.watermarkConfig.content" style="width: 240px; margin-right: 20px" clearable/>
      </el-row>
      <el-row>
        <span style="font-size: 14px; font-weight: normal">展示模式：</span>
        <el-select v-model="mergeRecordOptions.renderMode" placeholder="请选择展示模式"
                   style="width: 240px; margin-right: 20px">
          <el-option
            v-for="(item,index) in [{label: '裁剪', value: '0'},
                                    {label: '缩放', value: '1'}]"
            :key="'renderMode'+index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-button :disabled="mergeRecordOptions.state === 1" @click="mergeRecordHandle(mergeRecordOptions.state?0:1)">
          {{mergeRecordOptions.state === 2?"停止":"开启"}}录制{{mergeRecordOptions.state === 1?"中。。。":""}}
        </el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="点播"
      :close-on-click-modal="false"
      :visible.sync="playDialogVisible"
      width="90%"
      destroy-on-close
      style="max-height: 100%">
      <iframe :src="playPageUrl" style="width: 100%; height: 60vh; border: none"></iframe>
    </el-dialog>

    <el-dialog title="互动白板" :visible.sync="wbDialogVisible" :fullscreen="true" >
     <WhiteBoard  :parentData="{pageName,jyxRtcJoinRoomOptions,jyxRtcLoginOptions,rtcEngine}"/>
    </el-dialog>
  </div>

</template>

<script>
import {init} from "../js/rtcEngine.min.js";
import {eventNameConstants, jyxRtcConstants, mediaTypeConstants, recordTypeConstants} from "../util/Constants.js";
import {showErrorMessage, download} from "../util/index.js";
import Media from "../lib/Media.js";
import Moment from "moment";
import WhiteBoard from "@/components/WhiteBoard.vue";

export default {
  components: {WhiteBoard},
    data() {
        return {
            wbDialogVisible:false,
            intervalIds: [],
            pageName: "video",
            jyxRtcLoginOptions: null,
            jyxRtcJoinRoomOptions: null,
            rtcEngine: null,
            devices: {},
            mediaPerLine: 4,
            mediaList: [],
            mediaLists: [],
            videoList: [],
            audioList: [],
            roomOnlineUsers: [],
            checkedMedia: null,
            roomMessageElement: null,
            roomMessageList: [],
            checkedUsers: [],
            checkAll: false,
            isIndeterminate: true,
            message: "hello",
            shareScreenState: 0,
            recordState: 0,
            imageData: "",
            captureDialogVisible: false,
            notifyList: [],
            isRefreshPage: false,
            recordTypeOptions: [{label: "单录音频", value: "audio"}, {label: "单录视频", value: "video"}, {
                label: "合成录制",
                value: "stream"
            }],
            recordType: "video",
            mediaUserInfoList: [],
            mediaUserInfoOptions: [],
            recordUserId: "",
            mergeModelOptions: ["LR-M", "RL-M", "LR-PIP", "RL-PIP"],
            mergeModel: "LR-M",
            // todo
            // externalAudioUrl: "http://localhost:8080/file/stream/local",
            externalAudioUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + "/111.mp3",
            isLoop: false,
            isPlay: true,
            playAudioState: 0,
            checkedCutLocalAudioMedia: null,
            cutLocalAudioDialogVisible: false,
            cutLocalAudioState: 0,
            isRealTime: false,
            cutLocalAudioBase64: "",
            mergeRecordSetDialogVisible: false,
            mergeRecordOptions: {
                options: {
                    roomId: "",
                    tagName: "",
                    recordConfig: {
                        streamTypes: "2",
                        mixedVideoLayout: "0_1",
                        videoUsers: [],
                        audioUserIds: [],
                        transcodingConfig: {
                            width: 1920,
                            height: 1080,
                            frameRate: 15,
                            backgroundColor: ""
                        }

                    },
                    watermarkConfig: {
                        type: "2",
                        content: "",
                        style: {
                            fontSize: 20,
                            fontColor: "#FF0000",
                            fontWeight: "normal"
                        },
                        position: "1",
                        gapX: 20,
                        gapY: 20
                    },
                    isRedundance: true
                },
                // 定时关闭
                mergeRecordHandleTimeout: 0,
                checkedResolvingPower: {id: 0, label: "640*480", width: 640, height: 480},
                renderMode: "0",
                state: 0,
                recordTaskId: ""
            },
            playPageUrl: "",
            playDialogVisible: false
        };
    },
    watch: {
        roomMessageList: function () {
            this.$nextTick(() => {
                if (this.roomMessageElement && this.roomMessageElement.autoScrollBottom) {
                    this.roomMessageElement.scrollTop = this.roomMessageElement.scrollHeight;
                }
            });
        },
        mediaList: function () {
            if (this.checkedMedia) {
                // 要抓拍的视频被关闭时清除选择
                let flag = false;
                this.mediaList.forEach((media) => {
                    if (this.checkedMedia.id === media.id) {
                        flag = true;
                    }
                });
                if (!flag) {
                    this.checkedMedia = null;
                }
            }
            if (this.checkedCutLocalAudioMedia) {
                // 要录制的音频被关闭时清除选择
                let flag = false;
                this.mediaList.forEach((media) => {
                    if (this.checkedCutLocalAudioMedia.id === media.id) {
                        flag = true;
                    }
                });
                if (!flag) {
                    if (this.cutLocalAudioState) {
                        this.cutLocalAudioHandle(0);
                    }
                    this.checkedCutLocalAudioMedia = null;
                }
            }
            // 获取video/screen类型的媒体
            this.videoList = this.mediaList.filter((media) => {
                // 本地共享不渲染
                if (media.mediaType === mediaTypeConstants.SCREEN_VIDEO && media.userId === this.jyxRtcLoginOptions.userId) {
                    return false;
                }
                // 渲染共享和视频
                if (media && [mediaTypeConstants.VIDEO, mediaTypeConstants.SCREEN_VIDEO].indexOf(media.mediaType) !== -1) {
                    return true;
                }
                return false;
            });
            // console.log("videoList", this.videoList);
            // 获取audio类型的媒体
            this.audioList = this.mediaList.filter((media) => {
                if (media && [mediaTypeConstants.AUDIO, mediaTypeConstants.EXTERNAL_AUDIO].indexOf(media.mediaType) !== -1) {
                    if (media.userId === this.jyxRtcLoginOptions.userId) {
                        media.muted = true;
                    }
                    return media;
                }
            });
            // console.log("audioList", this.audioList);
            // 将video类型的媒体分组
            this.mediaLists = this.group(this.videoList, this.mediaPerLine);
            // console.log("mediaLists", this.mediaLists);
            // 修改录制参数
            this.changeMediaUserInfoOptions();
            // 重新渲染
            this.$nextTick(() => {
                this.videoList.forEach((media) => {
                    if (media.mediaType === mediaTypeConstants.VIDEO && media.deviceId) {
                        this.rtcEngine.renderVideo(media.userId, null, media.deviceId, this.$refs[media.ref][0]);
                    }
                    if ([mediaTypeConstants.VIDEO, mediaTypeConstants.SCREEN_VIDEO].indexOf(media.mediaType) !== -1 && media.mediaId) {
                        this.rtcEngine.renderVideo(media.userId, media.mediaId, null, this.$refs[media.ref][0]);
                    }
                });
                this.audioList.forEach((media) => {
                    // 本地音频不渲染
                    if (media.userId === this.jyxRtcLoginOptions.userId) {
                        return;
                    }
                    this.rtcEngine.renderAudio(media.userId, media.mediaId, this.$refs[media.ref][0]);
                });
            });
        }
    },
    computed: {
        onlineUsers: {
            get() {
                return this.$store.state.common.onlineUsers;
            },
            set(val) {
                this.$store.commit("common/updateOnlineUsers", val);
            }
        }
    },
    created() {
        console.log(this.pageName + " created");
        if (sessionStorage.getItem(jyxRtcConstants.JYX_RTC_BEFORE_PAGE_NAME) === this.pageName) {
        //  刷新
            this.isRefreshPage = true;
        } else {
            sessionStorage.setItem(jyxRtcConstants.JYX_RTC_BEFORE_PAGE_NAME, this.pageName);
        }
    },
    mounted() {
        console.log(this.pageName + " mounted");
        this.jyxRtcLoginOptions = JSON.parse(sessionStorage.getItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS));
        if (!this.jyxRtcLoginOptions) {
            this.$message({
                type: "error",
                message: "登陆已失效，请重新登录!",
                duration: 1500
            });
            this.goto({path: "login"});
            return;
        }
        this.jyxRtcJoinRoomOptions = JSON.parse(sessionStorage.getItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS));
        if (!this.jyxRtcJoinRoomOptions) {
            this.$message({
                type: "error",
                message: "房间已失效!",
                duration: 1500
            });
            this.goto({path: "message-chat"});
            return;
        }
        // 初始化rtcEngine
        this.init();
        // 消息订阅
        this.subscribeEventHandle();
        if (this.isRefreshPage) {
            this.isRefreshPage = false;
            // 返回登陆页
            this.leaveRoom();
            this.goto({path: "login"});
        } else {
        // 正常登录
            this.joinRoomSuccessHandle();
        }
    },
    destroyed() {
        console.log(this.pageName + " destroyed");
        this.notifyList.forEach((notify) => {
            if (notify) {
                notify.close();
            }
        });
        // 销毁时离开房间
        if (this.jyxRtcJoinRoomOptions) {
            this.leaveRoom();
        }
    },
    methods: {
      async uploadRefImage() {
        let imgFile = this.$refs["refImgUploadInput"].files[0];
        if (imgFile === void 0) {
          return "";
        }
        this.$refs["refImgUploadInput"].value = '';
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.readAsDataURL(imgFile);
          reader.onload = (e) => {
            resolve(e.target.result);
          };
        });
      },
     async startDetection(type){
        if (!this.checkedMedia) {
          this.$message({
            type: "error",
            message: "请选择一个操作对象!",
            duration: 1500
          });
          return;
        }
        let options = {
          deviceId: this.checkedMedia.deviceId,
          mediaId: this.checkedMedia.mediaId,
          isDrawBox: true,
          interval: 500
        }
        if(type === 1){//人脸识别
            let callback = (result) => {
              console.log(result.score)
            };
            this.rtcEngine.startFaceRecognition(options,callback).then((result) => {
              this.intervalIds.push(result);
            }).catch((error) => {
              console.log('error', error)
            });
        }else if(type === 2){//出入框检测
            let callback = (result) => {
              console.log(result.actionType === 0 ? "出框" : "入框");
              if(result.actionType === 0 ){
                this.$message({
                  type: "info",
                  message: "人脸出框!",
                  duration: 1000
                });
              }
            };
            this.rtcEngine.startInOutDetection(options, callback).then((result) => {
              this.intervalIds.push(result);
            }).catch((error) => {
              console.log('error', error)
            });
        }else if(type === 3){//人员变换
          options.inputImage = await this.uploadRefImage();
            let callback = (result) => {
              console.log(result.samePerson === 0 ? "非同一个人" : "同一个人");
              if(result.samePerson === 0 ){
                this.$message({
                  type: "info",
                  message: "不是同一个人!",
                  duration: 1000
                });
              }
            };
            this.rtcEngine.startChangeDetection(options, callback).then((result) => {
              this.intervalIds.push(result);
            }).catch((error) => {
              console.log('error', error)
            });
        }
      },
      stopAll(){
          this.intervalIds.forEach((intervalId) => {
            this.rtcEngine.stopFaceRecognition({ 'eventId': intervalId }).then((result) => {
            }).catch((error) => {
              console.log('error', error)
            })
          });
        this.intervalIds = [];
        },
        goto({path, query}) {
            if (path === "login" && this.rtcEngine) {
                sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS);
                sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS);
                this.rtcEngine.destroy();
            }

            if (this.rtcEngine) {
                // 取消订阅
                this.unSubscribeEventHandle();
            }
            this.$router.push({path: "/" + path});
        },
        init() {
            console.log("init");
            this.rtcEngine = init();
        },
        joinRoom() {
            console.log("joinRoom");
            this.rtcEngine.joinRoom(this.jyxRtcJoinRoomOptions.roomId, this.jyxRtcJoinRoomOptions.roomPassword)
                .then(() => {
                    console.log("joinRoom success");
                    this.joinRoomSuccessHandle();
                })
                .catch((error) => {
                    console.log("joinRoom error", error);
                    showErrorMessage("进入房间失败!", error);
                    this.goto({path: "message-chat"});
                });
        },
        joinRoomSuccessHandle() {
            this.getRoomOnlineUsers(this.jyxRtcJoinRoomOptions.roomId);
            this.getMediaDevices();
            // roomMessage，但鼠标在该窗口时，禁用滚动到最下层逻辑
            this.roomMessageElement = document.getElementById("roomMessageElement");
            this.roomMessageElement.onmouseenter = () => {
                this.roomMessageElement.autoScrollBottom = false;
            };
            this.roomMessageElement.onmouseleave = () => {
                this.roomMessageElement.autoScrollBottom = true;
            };
        },
        getMediaDevices() {
            this.rtcEngine.getMediaDevices()
                .then((devices) => {
                    console.log("getMediaDevices success", devices);
                    devices.micDevices.forEach((micDevice) => {
                        micDevice.useState = 0;
                    });
                    devices.cameraDevices.forEach((cameraDevice) => {
                        cameraDevice.useState = 0;
                    });
                    // devices.cameraDevices = [];
                    // let extraDevice = {deviceId: "environment", deviceName: "额外设备", useState: 0};
                    // devices.cameraDevices.push(extraDevice);
                    // devices.cameraDevices.push({deviceId: "user", deviceName: "额外设备1", useState: 0});
                    this.devices = devices;
                })
                .catch((error) => {
                    console.log("getMediaDevices error", error);
                });
        },
        logout() {
            console.log("logout ");
            this.rtcEngine.logout()
                .then(() => {
                    console.log("logout success");
                    sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS);
                    sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS);
                    this.goto({path: "login"});
                })
                .catch((error) => {
                    console.log("logout error", error);
                    showErrorMessage("登出失败!", error);
                });
        },
        getOnlineUsers(isRefresh) {
            console.log("getOnlineUsers ");
            this.rtcEngine.getOnlineUsers()
                .then((users) => {
                    console.log("getOnlineUsers success", users);
                    // 去除自身
                    let item = null;
                    for (let i = 0; i < users.length; i++) {
                        item = users[i];
                        if (item.userId === this.jyxRtcLoginOptions.userId) {
                            users.splice(i--, 1);
                            break;
                        }
                    }
                    // 自定义一些属性
                    this.onlineUsers = users.map((user) => {
                        // userExtInfo为json串，需转换
                        user.userExtInfo = user.userExtInfo || JSON.stringify({userId: user.userId, userName: user.userId});
                        user.userExtInfo = JSON.parse(user.userExtInfo);
                        user.isInRoom = false;
                        return user;
                    });
                    this.updateIsInRoom();
                    if (isRefresh) {
                        this.$message({
                            type: "success",
                            message: "重新获取在线用户列表成功!",
                            duration: 1500
                        });
                    }
                })
                .catch((error) => {
                    console.log("getOnlineUsers error", error);
                    showErrorMessage("获取在线用户列表失败!", error);
                });
        },
        getRoomOnlineUsers(roomId) {
            console.log("getRoomOnlineUsers ", roomId);
            this.rtcEngine.getRoomOnlineUsers(roomId)
                .then((users) => {
                    console.log("getRoomOnlineUsers success", users);
                    this.roomOnlineUsers = users;
                    this.updateIsInRoom();
                })
                .catch((error) => {
                    console.log("getRoomOnlineUsers error", error);
                    showErrorMessage("获取房间用户列表失败!", error);
                });
        },
        sendRoomMessage() {
            if (!this.message) {
                this.$message({
                    type: "error",
                    message: "发送内容不能为空!",
                    duration: 1500
                });
                return;
            }
            let options = {
                roomId: this.jyxRtcJoinRoomOptions.roomId,
                excludeUserIds: [this.jyxRtcLoginOptions.userId].concat(this.checkedUsers),
                message: this.message
            };
            console.log("sendRoomMessage ", options);
            let roomMessage = {
                sourceUserId: this.jyxRtcLoginOptions.userId,
                sourceUserExtInfo: JSON.parse(this.jyxRtcLoginOptions.userExtInfo),
                message: this.message,
                sendState: 1,
                time: new Date()
            };
            this.roomMessageList.push(roomMessage);
            this.rtcEngine.sendRoomMessage(options)
                .then(() => {
                    console.log("sendRoomMessage success");
                    this.message = "";
                    roomMessage.sendState = 2;
                })
                .catch((error) => {
                    console.log("sendRoomMessage error", error);
                    roomMessage.sendState = 0;
                    showErrorMessage("消息发送失败!", error);
                });
        },
        leaveRoom() {
            this.stopAll();
            console.log("leaveRoom ");
            this.rtcEngine.leaveRoom()
                .then(() => {
                    console.log("leaveRoom success");
                    this.unSubscribeEventHandle();
                    sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_JOIN_ROOM_OPTIONS);
                    this.jyxRtcJoinRoomOptions = null;
                    this.goto({path: "message-chat"});
                })
                .catch((error) => {
                    console.log("leaveRoom error", error);
                });
        },
        invite(options) {
            console.log("invite ", options);
            if (!options.userIds || !options.userIds.length) {
                this.$message({
                    type: "error",
                    message: "至少选择一个邀请对象!",
                    duration: 1500
                });
                return;
            }
            this.rtcEngine.invite(options)
                .then(() => {
                    console.log("invite success");
                    this.checkedUsers = [];
                    this.$message({
                        type: "success",
                        message: "发送邀请成功!",
                        duration: 1500
                    });
                })
                .catch((error) => {
                    console.log("invite error", error);
                    showErrorMessage("邀请失败!", error);
                });
        },
        answerInvite(answer, inviteResult) {
            console.log("answerInvite ", answer, inviteResult);
            this.rtcEngine.answerInvite({sourceUserId: inviteResult.sourceUserId, answer: answer})
                .then(() => {
                    console.log("answerInvite success");
                    this.$message({
                        type: "success",
                        message: "消息回复成功!",
                        duration: 1500
                    });
                })
                .catch((error) => {
                    console.log("answerInvite error", error);
                });
        },
        capture() {
            if (!this.checkedMedia) {
                this.$message({
                    type: "error",
                    message: "请选择一个抓拍对象!",
                    duration: 1500
                });
                return;
            }
            console.log("capture ", this.checkedMedia);
            this.rtcEngine.capture(this.checkedMedia.deviceId, this.checkedMedia.mediaId)
                .then((imageData) => {
                    console.log("capture success", imageData);
                    this.imageData = imageData;
                    this.captureDialogVisible = true;
                    this.$nextTick(() => {
                        let captureImage = this.$refs.captureImage[0];
                        console.log("captureImage ", captureImage);
                    });
                })
                .catch((error) => {
                    console.log("capture error", error);
                });
        },
        audioHandle(handleType, device) {
            switch (handleType) {
                case 0:
                    this.stopPublishAudio(device);
                    break;
                case 1:
                    this.startPublishAudio(device);
                    break;
                default:
                    break;
            }
        },
        startPublishAudio(device) {
            console.log("startPublishAudio ", device);
            // 临时字段，异常时还原
            let useState = device.useState;
            device.useState = 1;
            let appData = {
                ...this.jyxRtcLoginOptions
            };
            this.rtcEngine.startPublishAudio({
                deviceId: device.deviceId,
                appData: appData
            })
                .then(() => {
                    console.log("startPublishAudio success");
                    device.useState = 2;
                    let mediaName = `本地音频(${device.deviceName})`;
                    let media = new Media();
                    media.userId = this.jyxRtcLoginOptions.userId;
                    media.userInfo = {
                        userId: this.jyxRtcLoginOptions.userId,
                        userName: JSON.parse(this.jyxRtcLoginOptions.userExtInfo).userName
                    };
                    media.mediaId = null;
                    media.deviceId = device.deviceId;
                    media.mediaType = mediaTypeConstants.AUDIO;
                    media.appData = appData;
                    media.ref = media.id;
                    media.mediaName = mediaName;
                    this.mediaList.push(media);

                    // getVolume测试
                    // let options = {deviceId: device.deviceId, mediaId: null};
                    // let callback = (volume) => {
                    //     console.log("volume", volume);
                    // };
                    // this.rtcEngine.getVolume(options, callback)
                    //     .then((result) => {
                    //         console.log("getVolume success", result);
                    //     })
                    //     .catch((error) => {
                    //         console.log("getVolume error", error);
                    //     });

                })
                .catch((error) => {
                    console.log("startPublishAudio error", error);
                    device.useState = useState;
                    showErrorMessage("音频开启失败，请检查设备是否已被占用!", error);
                });
        },
        stopPublishAudio(device) {
            console.log("stopPublishAudio ", device);
            let useState = device.useState;
            device.useState = 1;
            this.rtcEngine.stopPublishAudio()
                .then(() => {
                    console.log("stopPublishAudio success");
                    device.useState = 0;
                    this.deleteMedia({deviceId: device.deviceId, mediaType: mediaTypeConstants.AUDIO});
                })
                .catch((error) => {
                    console.log("stopPublishAudio error", error);
                    device.useState = useState;
                });
        },
        videoHandle(handleType, device) {
            switch (handleType) {
                case 0:
                    this.stopPublishVideo(device);
                    break;
                case 1:
                    this.startPublishVideo(device);
                    break;
                default:
                    break;
            }
        },
        startPublishVideo(device) {
            console.log("startPublishVideo ", device);
            let videoIndex = 0;
            this.mediaList.forEach((media) => {
                if ([mediaTypeConstants.VIDEO, mediaTypeConstants.SCREEN_VIDEO].includes(media.mediaType) && media.userId === this.jyxRtcLoginOptions.userId) {
                    videoIndex++;
                }
            });
            let useState = device.useState;
            device.useState = 1;
            let appData = {
                ...this.jyxRtcLoginOptions,
                videoIndex
            };
            let deviceId = device.deviceId;
            this.rtcEngine.startPublishVideo({
                deviceId: deviceId,
                videoOption: {
                    width: 320,
                    height: 240,
                    frameRate: 15,
                    // virtualBackground: {
                    //     src: "base64",
                    //     repetition: "zoom"
                    // }
                },
                appData: appData
            })
                .then(() => {
                    console.log("startPublishVideo success");
                    device.useState = 2;
                    let mediaName = `本地视频(${device.deviceName})`;
                    let media = new Media();
                    media.userId = this.jyxRtcLoginOptions.userId;
                    media.userInfo = {
                        userId: this.jyxRtcLoginOptions.userId,
                        userName: JSON.parse(this.jyxRtcLoginOptions.userExtInfo).userName
                    };
                    media.mediaId = null;
                    media.deviceId = deviceId;
                    media.mediaType = mediaTypeConstants.VIDEO;
                    media.appData = appData;
                    media.ref = media.id;
                    media.mediaName = mediaName;
                    this.mediaList = [media].concat(this.mediaList);
                })
                .catch((error) => {
                    console.log("startPublishVideo error", error);
                    device.useState = useState;
                    showErrorMessage("视频开启失败，请检查设备是否已被占用!", error);
                });
        },
        stopPublishVideo(device) {
            let deviceId = device.deviceId;
            console.log("stopPublishVideo ", deviceId);
            let useState = device.useState;
            device.useState = 1;
            this.rtcEngine.stopPublishVideo(deviceId)
                .then(() => {
                    console.log("stopPublishVideo success");
                    device.useState = 0;
                    this.deleteMedia({deviceId: deviceId, mediaType: mediaTypeConstants.VIDEO});
                })
                .catch((error) => {
                    console.log("stopPublishVideo error", error);
                    device.useState = useState;
                });
        },
        shareScreenHandle(handleType) {
            switch (handleType) {
                case 0:
                    this.stopShareScreen();
                    break;
                case 1:
                    this.startShareScreen({videoOption: {bitRate: 1500000}, appData: {...this.jyxRtcLoginOptions}});
                    break;
                default:
                    break;
            }
        },
        startShareScreen(options) {
            console.log("startShareScreen ", options);
            let shareScreenState = this.shareScreenState;
            this.shareScreenState = 1;
            this.rtcEngine.startShareScreen(options)
                .then(() => {
                    console.log("startShareScreen success");
                    this.shareScreenState = 2;
                    let mediaName = "本地分享屏幕";
                    let media = new Media();
                    media.userId = this.jyxRtcLoginOptions.userId;
                    media.userInfo = {
                        userId: this.jyxRtcLoginOptions.userId,
                        userName: JSON.parse(this.jyxRtcLoginOptions.userExtInfo).userName
                    };
                    media.mediaId = null;
                    media.deviceId = null;
                    media.mediaType = mediaTypeConstants.SCREEN_VIDEO;
                    media.appData = options.appData;
                    media.ref = media.id;
                    media.mediaName = mediaName;
                    this.mediaList.push(media);
                })
                .catch((error) => {
                    console.log("startShareScreen error", error);
                    this.shareScreenState = shareScreenState;
                });
        },
        stopShareScreen() {
            console.log("stopShareScreen");
            let shareScreenState = this.shareScreenState;
            this.rtcEngine.stopShareScreen()
                .then(() => {
                    console.log("stopShareScreen success");
                    this.shareScreenState = 0;
                    this.deleteMedia({mediaType: mediaTypeConstants.SCREEN_VIDEO});
                })
                .catch((error) => {
                    console.log("stopShareScreen error", error);
                    this.shareScreenState = shareScreenState;
                });
        },
        recordHandle(handleType) {
            let errorMessage = null;
            if (!this.jyxRtcJoinRoomOptions.roomId) {
                errorMessage = "房间号不能为空";
            }
            let userId = this.recordUserId;
            switch (handleType) {
                case 0:
                    if (!userId && [recordTypeConstants.AUDIO, recordTypeConstants.VIDEO].indexOf(this.recordType) !== -1) {
                        errorMessage = "请选择要停止录制的用户";
                        break;
                    }
                    // 停止合成录制时不能传userId
                    if (this.recordType === recordTypeConstants.STREAM) {
                        userId = "";
                    }
                    this.stopRecord({
                        roomId: this.jyxRtcJoinRoomOptions.roomId,
                        userId: userId,
                        type: this.recordType
                    });
                    break;
                case 1:
                    if (!userId) {
                        errorMessage = "请选择要录制的用户";
                        break;
                    }
                    if (this.recordType !== recordTypeConstants.STREAM) {
                        this.mergeModel = "";
                    }
                    this.startRecord({
                        roomId: this.jyxRtcJoinRoomOptions.roomId,
                        userId: userId,
                        type: this.recordType,
                        mergeModel: this.mergeModel
                    });
                    break;
                default:
                    break;
            }
            if (errorMessage) {
                this.$message({
                    type: "error",
                    message: errorMessage,
                    duration: 1500
                });
            }
        },
        startRecord(options) {
            console.log("startRecord", options);
            let recordState = this.recordState;
            this.recordState = 1;
            this.rtcEngine.startRecord(options)
                .then(() => {
                    console.log("startRecord success");
                    this.recordState = 2;
                })
                .catch((error) => {
                    console.log("startRecord error", error);
                    this.recordState = recordState;
                });
        },
        stopRecord(options) {
            console.log("stopRecord", options);
            let recordState = this.recordState;
            this.rtcEngine.stopRecord(options)
                .then(() => {
                    console.log("stopRecord success");
                    this.recordState = 0;
                })
                .catch((error) => {
                    console.log("stopRecord error", error);
                    this.recordState = recordState;
                });
        },
        playAudioHandle(handleType) {
            switch (handleType) {
                case 0:
                    this.stopPlayAudio();
                    break;
                case 1:
                    this.startPlayAudio({url: this.externalAudioUrl, isLoop: this.isLoop, isPlay: this.isPlay, appData: {}});
                    break;
                default:
                    break;
            }
        },
        startPlayAudio(options) {
            console.log("startPlayAudio", options);
            let playAudioState = this.playAudioState;
            this.playAudioState = 1;
            this.rtcEngine.startPlayAudio(options)
                .then(() => {
                    console.log("startPlayAudio success");
                    this.playAudioState = 2;
                })
                .catch((error) => {
                    console.log("startPlayAudio error", error);
                    this.playAudioState = playAudioState;
                });
        },
        stopPlayAudio() {
            console.log("stopPlayAudio");
            let playAudioState = this.playAudioState;
            this.rtcEngine.stopPlayAudio()
                .then(() => {
                    console.log("stopPlayAudio success");
                    this.playAudioState = 0;
                })
                .catch((error) => {
                    console.log("stopPlayAudio error", error);
                    this.playAudioState = playAudioState;
                });
        },
        cutLocalAudioHandle(handleType) {
            if (handleType === 0 && !this.cutLocalAudioState) {
                return;
            }
            let deviceId = this.checkedCutLocalAudioMedia.deviceId;
            let mediaId = this.checkedCutLocalAudioMedia.mediaId;
            if (handleType === 1 && !this.cutLocalAudioDialogVisible) {
                this.cutLocalAudioDialogVisible = true;
            }
            let maxInterval = 6.4 * 1000;
            let interval = 160;
            switch (handleType) {
                case 0:
                    this.stopCutLocalAudio({mediaId, deviceId});
                    break;
                case 1:
                    this.cutLocalAudioBase64 = "";
                    this.startCutLocalAudio({
                        mediaId,
                        deviceId,
                        audioConfig: {dataType: 2, isRealTime: this.isRealTime, interval: interval}
                    }, (data) => {
                        console.log("cutLocalAudio data:", data);
                        if (this.isRealTime) {
                            //  实时
                            if (maxInterval <= 0) {
                                this.stopCutLocalAudio({mediaId, deviceId});
                                return;
                            }
                            this.cutLocalAudioBase64 += (data + "、");
                            maxInterval = maxInterval - interval;
                        } else {
                            let audio = this.$refs.cutLocalAudio;
                            audio.src = data;
                        }
                        // console.log("base64List.add(\"" + (data.substring("data:audio/wav;base64,".length, data.length)) + "\");");

                    });
                    break;
                default:
                    break;
            }
        },
        startCutLocalAudio(options, callback) {
            console.log("startCutLocalAudio", options, callback);
            let cutLocalAudioState = this.cutLocalAudioState;
            this.cutLocalAudioState = 1;
            this.rtcEngine.startCutLocalAudio(options, callback)
                .then(() => {
                    console.log("startCutLocalAudio success");
                    this.cutLocalAudioState = 2;
                })
                .catch((error) => {
                    console.log("startCutLocalAudio error", error);
                    this.cutLocalAudioState = cutLocalAudioState;
                });
        },
        stopCutLocalAudio(options) {
            console.log("stopCutLocalAudio", options);
            if (!this.cutLocalAudioState) {
                return;
            }
            let cutLocalAudioState = this.cutLocalAudioState;
            this.rtcEngine.stopCutLocalAudio(options)
                .then((result) => {
                    console.log("stopCutLocalAudio success", result);
                    this.cutLocalAudioState = 0;
                })
                .catch((error) => {
                    console.log("stopCutLocalAudio error", error);
                    this.cutLocalAudioState = cutLocalAudioState;
                });
        },
        copyHandle(content) {
            console.log("copyHandle", content);
            navigator.clipboard.writeText(content).then(() => {
                console.log("copyHandle success");
            });
        },
        mediaHandle(media) {
            console.log("mediaHandle", media);
            let state = media.state;
            media.state = 1;
            if (media.deviceId) {
                // 本地流媒体
                if (state === 2) {
                    // 开始->停止生产
                    this.rtcEngine.pausePublishAudio(media.deviceId)
                        .then(() => {
                            console.log("pausePublishAudio success");
                            media.state = 0;
                        })
                        .catch((error) => {
                            console.log("pausePublishAudio error", error);
                            media.state = state;
                        });
                    this.rtcEngine.pausePublishVideo(media.deviceId)
                        .then(() => {
                            console.log("pausePublishVideo success");
                            media.state = 0;
                        })
                        .catch((error) => {
                            console.log("pausePublishVideo error", error);
                            media.state = state;
                        });
                } else if (state === 0) {
                    // 停止->开始生产
                    this.rtcEngine.resumePublishAudio(media.deviceId)
                        .then(() => {
                            console.log("resumePublishAudio success");
                            media.state = 2;
                        })
                        .catch((error) => {
                            console.log("resumePublishAudio error", error);
                            media.state = state;
                        });
                    this.rtcEngine.resumePublishVideo(media.deviceId)
                        .then(() => {
                            console.log("resumePublishVideo success");
                            media.state = 2;
                        })
                        .catch((error) => {
                            console.log("resumePublishVideo error", error);
                            media.state = state;
                        });
                }

            }
            if (media.mediaId) {
                // 远程流媒体
                if (state === 2) {
                    // 开始-》停止消费
                    this.rtcEngine.pauseRenderMedia(media.userId, media.mediaId)
                        .then(() => {
                            console.log("pauseRenderMedia success");
                            media.state = 0;
                        })
                        .catch((error) => {
                            console.log("pauseRenderMedia error", error);
                            media.state = state;
                        });
                } else if (state === 0) {
                    // 停止-》开始消费
                    this.rtcEngine.resumeRenderMedia(media.userId, media.mediaId)
                        .then(() => {
                            console.log("resumeRenderMedia success");
                            media.state = 2;
                        })
                        .catch((error) => {
                            console.log("resumeRenderMedia error", error);
                            media.state = state;
                        });
                }
            }
        },
        mergeRecordHandle(handleType) {
            switch (handleType) {
                case 0:
                    this.stopMergeRecord();
                    break;
                case 1:
                    this.startMergeRecord();
                    break;
                default:
                    break;
            }
        },
        startMergeRecord(options = {}) {
            this.mergeRecordOptions.options.roomId = this.jyxRtcJoinRoomOptions.roomId;
            let videoUsers = [];
            let audioUserIds = [];
            let maxVideoUsersLength;
            switch (this.mergeRecordOptions.options.recordConfig.mixedVideoLayout) {
                case "0_1":
                    maxVideoUsersLength = 5;
                    break;
                case "0_2":
                    maxVideoUsersLength = 9;
                    break;
                case "1_0":
                    maxVideoUsersLength = 1;
                    break;
                case "1_1":
                    maxVideoUsersLength = 2;
                    break;
                case "1_2":
                    maxVideoUsersLength = 4;
                    break;
                case "1_3":
                    maxVideoUsersLength = 9;
                    break;
                case "2_0":
                    maxVideoUsersLength = 1;
                    break;
                case "2_1":
                    maxVideoUsersLength = 4;
                    break;
                case "2_2":
                    maxVideoUsersLength = 7;
                    break;
                default:
                    maxVideoUsersLength = 5;
                    break;
            }
            maxVideoUsersLength = Math.min(maxVideoUsersLength, this.videoList.length);
            for (let i = 0;i < maxVideoUsersLength;i++) {
                let video = this.videoList[i];
                videoUsers.push({
                    userId: video.userId,
                    index: i,
                    render_mode: this.mergeRecordOptions.renderMode,
                    videoIndex: video.appData ? video.appData.videoIndex : 0
                });
            }
            for (const item of this.audioList) {
                if (this.jyxRtcLoginOptions.userId !== item.userId) {
                    audioUserIds.push(item.userId);
                }
            }
            this.mergeRecordOptions.options.recordConfig.videoUsers = videoUsers;
            this.mergeRecordOptions.options.recordConfig.audioUserIds = audioUserIds;
            this.mergeRecordOptions.options.recordConfig.transcodingConfig.width = this.mergeRecordOptions.checkedResolvingPower.width;
            this.mergeRecordOptions.options.recordConfig.transcodingConfig.height = this.mergeRecordOptions.checkedResolvingPower.height;

            console.log("startMergeRecord", "options", this.mergeRecordOptions.options);
            let mergeRecordState = this.mergeRecordOptions.state;
            this.mergeRecordOptions.state = 1;
            console.log(JSON.stringify(this.mergeRecordOptions.options));
            this.rtcEngine.startMergeRecord(this.mergeRecordOptions.options)
                .then((recordTaskId) => {
                    console.log("startMergeRecord success", recordTaskId);
                    this.mergeRecordOptions.state = 2;
                    this.mergeRecordOptions.recordTaskId = recordTaskId;
                    if (this.mergeRecordOptions.mergeRecordHandleTimeout) {
                        setTimeout(() => {
                            this.mergeRecordHandle(0);
                        }, this.mergeRecordOptions.mergeRecordHandleTimeout);
                    }
                })
                .catch((error) => {
                    console.log("startMergeRecord error", error);
                    this.mergeRecordOptions.state = mergeRecordState;
                });
        },
        stopMergeRecord(roomId) {
            console.log("stopMergeRecord", roomId);
            let mergeRecordState = this.mergeRecordOptions.state;
            this.rtcEngine.stopMergeRecord(roomId, this.mergeRecordOptions.recordTaskId)
                .then(() => {
                    console.log("stopMergeRecord success");
                    this.mergeRecordOptions.state = 0;
                })
                .catch((error) => {
                    console.log("stopMergeRecord error", error);
                    this.mergeRecordOptions.state = mergeRecordState;
                });
        },
        getVideoUrls(roomId) {
            if (!roomId) {
                roomId = this.jyxRtcJoinRoomOptions.roomId;
            }
            let tagName = "";
            console.log("getVideoUrls", roomId, tagName);
            this.rtcEngine.getVideoUrls(roomId, tagName)
                .then((result) => {
                    console.log("getVideoUrls success", result);
                    if (!result.pageUrl || !result.videoUrls || !result.videoUrls.length) {
                        this.$message({
                            type: "error",
                            message: "房间还未生成录制文件",
                            center: true,
                            duration: 1500
                        });
                    } else {
                        this.playPageUrl = result.pageUrl;
                        this.playDialogVisible = true;
                    }
                })
                .catch((error) => {
                    console.log("getVideoUrls error", error);
                });
        },
        sendData() {
            let sendFile = this.$refs.sendFile;
            let file;
            if (!sendFile.files.length) {
                return this.$message({
                    type: "error",
                    message: "请选择一个文件上传",
                    duration: 1500
                });
            } else {
                file = sendFile.files[0];
            }
            if (file) {
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = (e) => {
                    console.log(e.target.result);
                    this.rtcEngine.sendData({data: e.target.result, label: file.name})
                        .then(() => {
                            console.log("sendData success");
                        })
                        .catch((error) => {
                            console.log("sendData error", error);
                        });
                };

            }
        },
        reloginHandle(jyxRtcLoginOptions) {
        // todo delete
            this.$confirm("连接断开，是否重新登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    console.log("login");
                    this.rtcEngine.login(jyxRtcLoginOptions)
                        .then(() => {
                            console.log("login success");
                            this.$message({
                                type: "success",
                                message: "登录成功!",
                                duration: 1500
                            });
                            if (!this.rtcEngine.roomClient) {
                                this.rtcEngine.joinRoom(this.jyxRtcJoinRoomOptions.roomId)
                                    .then(() => {
                                        this.getRoomOnlineUsers(this.jyxRtcJoinRoomOptions.roomId);
                                    })
                                    .catch((error) => {
                                        showErrorMessage("进入房间失败!", error);
                                    });
                            }
                            this.getOnlineUsers();
                        })
                        .catch((error) => {
                            console.log("login error", error);
                            showErrorMessage("登录失败!", error);
                            this.goto({path: "login"});
                        });
                })
                .catch(() => {
                    this.goto({path: "login"});
                });
        },
        onDisconnectHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_DISCONNECT, result);
            this.$confirm("连接异常，将跳转至登录页，请确认", "提示", {
                confirmButtonText: "确定",
                type: "error",
                showClose: false,
                showCancelButton: false
            })
                .then(() => {
                    this.goto({path: "login"});
                })
                .catch(() => {
                    this.goto({path: "login"});
                });
        },
        onReceiveRoomMessageHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_RECEIVE_ROOM_MESSAGE, result);
            result.sourceUserExtInfo = result.sourceUserExtInfo || JSON.stringify({
                userId: result.userId,
                userName: result.userId
            });
            if (result.sourceUserId !== this.jyxRtcLoginOptions.userId) {
                let roomMessage = {
                    sourceUserId: result.sourceUserId,
                    sourceUserExtInfo: JSON.parse(result.sourceUserExtInfo),
                    message: result.message,
                    sendState: 2,
                    time: new Date()
                };
                this.roomMessageList.push(roomMessage);
            }
        },
        onJoinRoomHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_JOIN_ROOM, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            this.getRoomOnlineUsers(this.jyxRtcJoinRoomOptions.roomId);
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, userExtInfo.userName || "未知"),
                        h("span", {
                            style: "font-size: 24px"
                        }, "进入房间")
                    ]
                ))
            });
            this.deleteCheckedUsers({userId: result.userId});
        },
        onLeaveRoomHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_LEAVE_ROOM, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            this.getRoomOnlineUsers(this.jyxRtcJoinRoomOptions.roomId);
            let item = null;
            for (let i = 0; i < this.checkedUsers.length; i++) {
                item = this.checkedUsers[i];
                if (item === result.userId) {
                    this.checkedUsers.splice(i--, 1);
                    break;
                }
            }
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: red; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", {
                            style: "font-size: 24px"
                        }, "离开房间")
                    ]
                ))
            });
        // this.deleteCheckedUsers({userId:result.userId});
        },
        onPublishMedia(result) {
            console.log("订阅通知事件", eventNameConstants.ON_PUBLISH_MEDIA, result);
            let onlineUser = this.getOnlineUser({userId: result.userId});
            if (!onlineUser) {
                onlineUser = {
                    userExtInfo: {
                        userName: "unknow"
                    }
                };
            }
            if (!onlineUser.userExtInfo) {
                onlineUser.userExtInfo = JSON.stringify({userName: result.userId});
            }
            if (result.mediaType === mediaTypeConstants.EXTERNAL_VIDEO) {
                let audio = window.document.createElement("audio");
                this.rtcEngine.renderAudio(result.userId, result.mediaId, audio);
                return;
            }
            let media = new Media();
            media.userId = result.userId;
            media.userInfo = {userId: result.userId, userName: onlineUser.userExtInfo.userName};
            media.mediaId = result.mediaId;
            media.deviceId = null;
            media.mediaType = result.mediaType;
            media.appData = result.appData;
            media.ref = result.mediaType + "_" + media.id;
            if (onlineUser) {
                media.mediaName = onlineUser.userExtInfo.userName;
            } else {
                media.mediaName = "未知";
            }
            this.mediaList.push(media);
        },
        onCancelPublishMedia(result) {
            console.log("订阅通知事件", eventNameConstants.ON_CANCEL_PUBLISH_MEDIA, result);
            this.deleteMedia({mediaId: result.mediaId});
        },
        onInviteHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_INVITE, result);
            result.sourceUserExtInfo = result.sourceUserExtInfo || JSON.stringify({
                userId: result.userId,
                userName: result.userId
            });
            let userExtInfo = JSON.parse(result.sourceUserExtInfo);
            let h = this.$createElement;
            let messageElements = [
                h("span", {
                    style: "color: #5daf34; font-size: 24px"
                }, userExtInfo.userName),
                h("span", null, "邀请你进入"),
                h("span", {
                    style: "color: #5daf34; font-size: 24px"
                }, result.roomId),
                h("span", null, "房间"),
                h("br", null, null)
            ];
            if (result.roomPassword) {
                messageElements.push(h("span", {style: "display: " + (result.roomPassword ? "block" : "none")}, "房间密码：" + result.roomPassword));
            }
            messageElements.push(h("span", {style: "color: red"}, "你当前已在房间中，如需进入其他房间，请先退出当前房间"));
            let notify = this.$notify({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    messageElements
                )),
                duration: 0
            });
            this.notifyList.push(notify);
            this.answerInvite("0", result);
        },
        onInviteAnswerHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_INVITE_ANSWER, result);
            result.targetUserExtInfo = result.targetUserExtInfo || JSON.stringify({
                userId: result.userId,
                userName: result.userId
            });
            let userExtInfo = JSON.parse(result.targetUserExtInfo);
            let h = this.$createElement;
            if (["0", "1"].indexOf(result.answer) !== -1) {
                this.$notify.info({
                    title: "消息",
                    dangerouslyUseHTMLString: true,
                    message: (h("p",
                        [
                            h("span", {
                                style: "color: #5daf34; font-size: 24px"
                            }, userExtInfo.userName),
                            h("span", {
                                style: result.answer === "1" ? "color: blue; font-size: 36px" : "color: red; font-size: 32px"
                            }, result.answer === "1" ? " 接受了 " : " 拒绝了 "),
                            h("span", null, "你的邀请")
                        ]
                    ))
                });
            }
        },
        onLoginHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_LOGIN, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", null, "已"),
                        h("span", {
                            style: "color: #5daf34; font-size: 24px"
                        }, "上线")
                    ]
                ))
            });
        // this.deleteCheckedUsers({userId:result.userId});
        },
        onLogoutHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_LOGOUT, result);
            result.userExtInfo = result.userExtInfo || JSON.stringify({userId: result.userId, userName: result.userId});
            let userExtInfo = JSON.parse(result.userExtInfo);
            this.getOnlineUsers();
            this.getRoomOnlineUsers(this.jyxRtcJoinRoomOptions.roomId);
            let item = null;
            for (let i = 0; i < this.checkedUsers.length; i++) {
                item = this.checkedUsers[i];
                if (item === result.userId) {
                    this.checkedUsers.splice(i--, 1);
                    break;
                }
            }
            let h = this.$createElement;
            this.$notify.info({
                title: "消息",
                dangerouslyUseHTMLString: true,
                message: (h("p",
                    [
                        h("span", {
                            style: "color: red; font-size: 24px"
                        }, userExtInfo.userName),
                        h("span", null, "已"),
                        h("span", {
                            style: "color: red; font-size: 24px"
                        }, "下线")
                    ]
                ))
            });
            this.deleteCheckedUsers({userId: result.userId});
        },
        onMediaEndHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_MEDIA_END, result);
            switch (result.mediaType) {
                case mediaTypeConstants.AUDIO:
                    this.devices.micDevices.forEach((device) => {
                        if (result.deviceId === device.deviceId) {
                            device.useState = 0;
                            this.deleteMedia({deviceId: result.deviceId, mediaType: mediaTypeConstants.AUDIO});
                        }
                    });
                    this.getMediaDevices();
                    break;
                case mediaTypeConstants.VIDEO:
                    this.devices.cameraDevices.forEach((device) => {
                        if (result.deviceId === device.deviceId) {
                            device.useState = 0;
                            this.deleteMedia({deviceId: result.deviceId, mediaType: mediaTypeConstants.VIDEO});
                        }
                    });
                    this.getMediaDevices();
                    break;
                case mediaTypeConstants.SCREEN_VIDEO:
                    this.shareScreenState = 0;
                    this.deleteMedia({mediaType: mediaTypeConstants.SCREEN_VIDEO});
                    break;
                case mediaTypeConstants.EXTERNAL_AUDIO:
                    this.playAudioState = 0;
                    break;
                default:
                    break;
            }
        },
        unSubscribeEventHandle() {
            console.log("unSubscribeEventHandle");
            //  取消订阅
            for (let key in eventNameConstants) {
                this.rtcEngine.unSubscribeEvent(eventNameConstants[key]);
            }
        },
        subscribeEventHandle() {
            console.log("subscribeEventHandle");
            //  取消订阅
            this.unSubscribeEventHandle();
            // 收到连接断开消息
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_DISCONNECT, this.onDisconnectHandle);
            // 收到群发消息
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_RECEIVE_ROOM_MESSAGE, this.onReceiveRoomMessageHandle);
            // 用户进入房间
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_JOIN_ROOM, this.onJoinRoomHandle);
            // 用户离开房间
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_LEAVE_ROOM, this.onLeaveRoomHandle);
            // 用户发布媒体流
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_PUBLISH_MEDIA, this.onPublishMedia);
            // 用户取消发布媒体流
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_CANCEL_PUBLISH_MEDIA, this.onCancelPublishMedia);
            // 用户暂停发布媒体流
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_PAUSE_PUBLISH_MEDIA, (result) => {
                console.log("订阅通知事件", eventNameConstants.ON_PAUSE_PUBLISH_MEDIA, result);
            });
            // 用户恢复发布媒体流
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_RESUME_PUBLISH_MEDIA, (result) => {
                console.log("订阅通知事件", eventNameConstants.ON_RESUME_PUBLISH_MEDIA, result);
            });
            // 收到呼叫邀请
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_INVITE, this.onInviteHandle);
            // 收到呼叫回复
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_INVITE_ANSWER, this.onInviteAnswerHandle);
            // 用户登录
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_LOGIN, this.onLoginHandle);
            // 用户登出
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_LOGOUT, this.onLogoutHandle);
            // 媒体流结束通知
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_MEDIA_END, this.onMediaEndHandle);
            // 用户发布文件数据
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_PUBLISH_DATA, (result) => {
                console.log("订阅通知事件", eventNameConstants.ON_PUBLISH_DATA, result);
                let blob = new Blob([result.data]);
                let fileName = result.label;
                download({blob, fileName});
            });
        },
        deleteMedia({id, deviceId, mediaType, mediaId}) {
            let item = null;
            let flag = false;
            for (let i = 0; i < this.mediaList.length; i++) {
                item = this.mediaList[i];
                flag = false;
                if (id && id === item.id) {
                    flag = true;
                }
                if (deviceId && deviceId === item.deviceId && mediaType === item.mediaType) {
                    flag = true;
                }
                if (mediaId && mediaId === item.mediaId) {
                    flag = true;
                }
                if (!deviceId && !item.mediaId && mediaType && mediaType === item.mediaType) {
                    flag = true;
                }
                if (flag) {
                    this.mediaList.splice(i--, 1);
                    break;
                }
            }
        },
        group(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, index += subGroupLength));
            }
            return newArray;
        },
        updateIsInRoom() {
            this.onlineUsers.forEach((onlineUser) => {
                onlineUser.isInRoom = false;
                this.roomOnlineUsers.forEach((roomOnlineUser) => {
                    if (roomOnlineUser.userId === onlineUser.userId) {
                        onlineUser.isInRoom = true;
                    }
                });
            });
        },
        handleCheckedUsersChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.onlineUsers.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.onlineUsers.length;
        },
        dateFormat(value, format = "YYYY-MM-DD HH:mm:ss") {
            return Moment(value)
                .format(format);
        },
        getOnlineUser({userId}) {
            for (const onlineUser of this.onlineUsers) {
                if (userId && userId === onlineUser.userId) {
                    return onlineUser;
                }
            }
            return null;
        },
        deleteCheckedUsers({userId}) {
            let item = null;
            for (let i = 0; i < this.checkedUsers.length; i++) {
                item = this.checkedUsers[i];
                if (item === userId) {
                    this.checkedUsers.splice(i--, 1);
                    break;
                }
            }
        },
        recordTypeChangeHandle(value) {
            this.changeMediaUserInfoOptions();
        },
        changeMediaUserInfoOptions() {
            let userIdList = [];
            let mediaUserInfoOptions = [];
            this.mediaList.forEach((media) => {
                if (userIdList.indexOf(media.userId) !== -1) {
                    return;
                }
                switch (this.recordType) {
                    case recordTypeConstants.AUDIO:
                        if (media.mediaType === mediaTypeConstants.AUDIO) {
                            mediaUserInfoOptions.push(media.userInfo);
                            userIdList.push(media.userId);
                        }
                        break;
                    case recordTypeConstants.VIDEO:
                        // if ([mediaTypeConstants.VIDEO, mediaTypeConstants.SCREEN].indexOf(media.mediaType) !== -1) {
                        //   mediaUserInfoOptions.push(media.userInfo);
                        //   userIdList.push(media.userId);
                        // }
                        // 共享视频不录制
                        if (mediaTypeConstants.VIDEO === media.mediaType) {
                            mediaUserInfoOptions.push(media.userInfo);
                            userIdList.push(media.userId);
                        }
                        break;
                    case recordTypeConstants.STREAM:
                        mediaUserInfoOptions.push(media.userInfo);
                        userIdList.push(media.userId);
                        break;
                    default:
                        break;
                }
            });
            if (userIdList.indexOf(this.recordUserId) === -1) {
                this.recordUserId = "";
            }
            this.mediaUserInfoOptions = mediaUserInfoOptions;
        },
        addMediaUserInfo(mediaUserInfo) {
            let isExist = false;
            this.mediaUserInfoList.forEach((item) => {
                if (item.userId === mediaUserInfo.userId) {
                    isExist = true;
                }
            });
            if (!isExist) {
                this.mediaUserInfoList.push(mediaUserInfo);
            }
        },
        removeMediaUserInfo(userId) {
            if (this.recordUserId === userId) {
                this.recordUserId = "";
            }
            for (let i = 0; i < this.mediaUserInfoList.length; i++) {
                let item = this.mediaUserInfoList[i];
                if (userId === item.userId) {
                    this.mediaUserInfoList.splice(i--, 1);
                    break;
                }
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .video-chat {
    .el-checkbox {
      margin-left: 20px;
      .el-checkbox__input {
        float: left;
      }
    }
  }

</style>
